
import FlatButton from "@/components/button/button";
import { BASE_URL } from "@/env";
import { Flex, Typography } from "antd";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const loginSSOLink = async (callback: () => void) => {
  try {
    const tokenKeycloak = await localStorage.getItem("keycloak-jwt");
    console.log("token", tokenKeycloak);

        if (tokenKeycloak !== null) {
            callback();
        } else {
            window.location.href = `${BASE_URL}` + "/keycloak/login-link";
        }
    } catch (error) {
        throw error;
    }
};

const loginOpenAMSSOLink = async (callback: () => void) => {
  try {
    const tokenKeycloak = await localStorage.getItem("openam-jwt");
    console.log("token", tokenKeycloak);

        if (tokenKeycloak !== null) {
            callback();
        } else {
            window.location.href = `${BASE_URL}` + "/openam/login-link";
        }
    } catch (error) {
        throw error;
    }
};


const Login: React.FC = () => {
  const navigate = useNavigate();
  const onServerHandleClick = useCallback(async () => {
    await loginSSOLink(() => {
      navigate("/authen");
    });
  }, [navigate]);

  const onOpenAMServerHandleClick = useCallback(async () => {
    await loginOpenAMSSOLink(() => {
      navigate("/authen");
    });
  }, []);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        ログイン画面
      </Typography.Text>
      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={onServerHandleClick}
      >
        KeyCloak認証
      </FlatButton>

      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={onOpenAMServerHandleClick}
      >
        OpenAM認証
      </FlatButton>

      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={() => {
          navigate("/register-ip-addr");
        }}
      >
        Register IP
      </FlatButton>

      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={() => {
          navigate("/login-ip-addr");
        }}
      >
        Login by IP
      </FlatButton>
    </Flex>
  );
};

export default Login;